import React, {Component} from 'react'
import { Table } from 'antd'
import "./style.less"
import { getCustomers } from "@/api/agent"
import { timestamp2DateStr } from "@/utils/format"

class CustomerList extends Component {
    constructor(pros) {
        super(pros);
        // TODO: 表格的宽度属性width不知道为什么不生效，站点id比较多时，展现不美观
        this.state = {
            loading: true,

            // 分页
            current: 1,
            pageSize: 8,
            offset: 0,

            columns: [
                {
                    title: "手机号",
                    dataIndex: "phoneNo",
                    width: 200,
                    key: "1",
                },
                {
                    title: "成为客户日期",
                    dataIndex: "createTime",
                    width: 200,
                    key: "2",
                },
                {
                    title: "上次消费日期",
                    dataIndex: "lastConsumeTime",
                    width: 200,
                    key: "3",
                },
                {
                    title: "上次登录日期",
                    dataIndex: "updateTime",
                    width: 200,
                    key: "4",
                },
            ],
            data: [
            ],
        }
    }

    renderData = () => {
        this.setState(
            {
                loading: true
            }
        );
        getCustomers(this.state.offset, this.state.pageSize)
            .then(data => {
                console.log(data);
                if (data.customerList) {
                    this.setState(
                        {
                            loading: false,
                            total: data.total,
                            data: data.customerList.map( (item, index) => {
                                return {
                                    "key": index,
                                    "phoneNo": item.phoneNo,
                                    "createTime": timestamp2DateStr(item.createTime),
                                    "lastConsumeTime": timestamp2DateStr(item.lastConsumeTime),
                                    "updateTime": timestamp2DateStr(item.updateTime),
                                    "siteIds": item.siteIds,
                                }
                            }),
                        },
                    );

                }
                }
            );
    };

    onPageChange = page => {
        this.setState(
            {
                current: page
            },
            () => {
                this.setState(
                    {
                        offset: (this.state.current - 1) * this.state.pageSize
                    },
                    () => {
                        this.renderData();
                    }
                );
            }
        );
    };

    componentDidMount() {
        this.renderData();
    }

    render() {
        return (
            <React.Fragment>
                <div className="consumer-list">
                    <div className="info">客户列表</div>
                    <Table bordered={true}
                           pagination={
                               {
                                   current: this.state.current,
                                   total: this.state.total,
                                   pageSize: this.state.pageSize,
                                   onChange: this.onPageChange,
                               }
                           }
                           loading={this.state.loading}
                           columns={this.state.columns}
                           dataSource={this.state.data}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default CustomerList;